import LayoutVersionManagerActionsItem from "../versionManagerFilters/filtersItem";
import LayoutVersionManagerActions from "./filters";
import LayoutVersionManagerActionsRoot from "./root";

export const VersionManagerActionsLayout = {
  Root: LayoutVersionManagerActionsRoot,
  Filters: LayoutVersionManagerActions,
  FiltersItem: LayoutVersionManagerActionsItem,
};
